export function getTenantIdFromPath() {
  // /t/<tenant-id>/... の形式のパスから tenant-id を取得する
  const match = /^\/t\/([^/]+)/.exec(window.location.pathname)
  if (match === null) {
    return ''
  }
  return match[1] ?? ''
}
